import React, { useState, useEffect } from "react";

export default function CPPtest(props) {
  const correctAnswers = [2, 0, 2, 1, 0, 2, 2, 0, 0, 0, 3, 2, 0, 0, 2, 1, 1, 0, 0, 2, 1, 0, 1, 1, 0];
  const que = {
    q1: {
      string: "1. What is the primary purpose of a constructor in C++?",
      options: ["To destroy an object", "To allocate memory", "To initialize an object", "To declare an object"],
      ans: 2
    },
    q2: {
      string: "2. Which keyword is used to define a class in C++?",
      options: ["class", "struct", "type", "object"],
      ans: 0
    },
    q3: {
      string: "3. In C++, how is memory allocated for a dynamically created object?",
      options: ["malloc()", "calloc()", "new", "alloc()"],
      ans: 2
    },
    q4: {
      string: "4. What is the output of 'cout << 5 / 2;' in C++?",
      options: ["2.5", "2", "2.0", "Error"],
      ans: 1
    },
    q5: {
      string: "5. Which operator is used to access the member functions and variables of an object in C++?",
      options: [".", "->", "::", "*"],
      ans: 0
    },
    q6: {
      string: "6. What does the 'virtual' keyword do in C++?",
      options: ["Defines a class as abstract", "Defines a class as final", "Enables polymorphism", "Disables inheritance"],
      ans: 2
    },
    q7: {
      string: "7. Which header file is needed for input and output operations in C++?",
      options: ["<input.h>", "<stdio.h>", "<iostream>", "<output.h>"],
      ans: 2
    },
    q8: {
      string: "8. What does the 'static' keyword mean in C++?",
      options: ["Memory allocation at compile-time", "Memory allocation at run-time", "Dynamic memory allocation", "No memory allocation"],
      ans: 0
    },
    q9: {
      string: "9. How do you declare a constant variable in C++?",
      options: ["const int x;", "constant x;", "int const x;", "int x; const;"],
      ans: 0
    },
    q10: {
      string: "10. Which operator is used to determine the size of a data type in C++?",
      options: ["sizeof()", "size()", "length()", "bytesize()"],
      ans: 0
    },
    q11: {
      string: "11. What is the output of 'cout << \"Hello\" + \"World\";' in C++?",
      options: ["HelloWorld", "Hello World", "HelloWorld", "Error"],
      ans: 3
    },
    q12: {
      string: "12. Which loop is used to iterate over a range of values in C++?",
      options: ["while", "do-while", "for", "repeat-until"],
      ans: 2
    },
    q13: {
      string: "13. What is the purpose of the 'new' operator in C++?",
      options: ["To allocate memory for an object", "To delete memory for an object", "To create a copy of an object", "To initialize an object"],
      ans: 0
    },
    q14: {
      string: "14. Which keyword is used to exit from a loop in C++?",
      options: ["break", "exit", "return", "continue"],
      ans: 0
    },
    q15: {
      string: "15. What is the output of 'cout << (10 > 5);' in C++?",
      options: ["True", "False", "1", "0"],
      ans: 2
    },
    q16: {
      string: "16. Which operator is used to dereference a pointer in C++?",
      options: ["&", "*", "-", "->"],
      ans: 1
    },
    q17: {
      string: "17. What is the correct syntax for a switch statement in C++?",
      options: ["case expression:", "switch(expression) { case: }", "switch(expression) { case value: }", "switch { case: }"],
      ans: 2
    },
    q18: {
      string: "18. What does the 'inline' keyword do in C++?",
      options: ["Forces the compiler to ignore the function", "Specifies that a function's code will be inserted inline", "Forces the function to be virtual", "Specifies that a function is a template"],
      ans: 1
    },
    q19: {
      string: "19. What is the purpose of the 'friend' keyword in C++?",
      options: ["To specify that a function is a friend function", "To specify that a function is a member function", "To specify that a function is virtual", "To specify that a function is a template"],
      ans: 0
    },
    q20: {
      string: "20. Which operator is used to perform explicit type conversion in C++?",
      options: ["cast", "explicit", "typecast", "convert"],
      ans: 2
    },
    q21: {
      string: "21. What does the 'endl' manipulator do in C++?",
      options: ["Ends the program", "Ends the line and flushes the output buffer", "Ends the line", "Ends the line without flushing the output buffer"],
      ans: 1
    },
    q22: {
      string: "22. Which operator is used to access elements of a structure in C++?",
      options: [".", "->", "*", "::"],
      ans: 0
    },
    q23: {
      string: "23. What is the output of 'cout << (3 * 5) / (2 + 1);' in C++?",
      options: ["2", "5", "3", "15"],
      ans: 1
    },
    q24: {
      string: "24. Which of the following is not a valid data type in C++?",
      options: ["int", "string", "char", "bool"],
      ans: 1
    },
    q25: {
      string: "25. What is the correct syntax for a function pointer in C++?",
      options: ["void (*ptr)();", "void *ptr();", "void ptr();", "void (*ptr);"],
      ans: 0
    }
  };

  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1>CPP <span>Skill</span> Test</h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1> 
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
          <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
